import Vue from 'vue';
import Vuex from 'vuex';
import { Toast } from 'vant';
import {
    pageByGroup,
    checkIsSinglePage,
    jumpSinglePage,
    findPageIdex,
    getMultiNextGroup,
    validatorQuestion,
    getAllAnswer,
    judgeGroupHaveAnswer,
    judgeGroupExistAnswer,
    hideBetweenPage
} from '@/libs/question-tool';
import { checkGroupExistShow } from '@/libs/question-util';
import browser from '@/libs/browser';
import { setTitle } from '@/libs/native';
import {
    CHANGE_PAGE,
    CHANGE_DISPLAY_QUESTION,
    CHANGE_IS_SINGLE_PAGE,
    CHANGE_CURRENT_PAGE,
    CHANGE_JUMP_HISTORY_STACK,
    CHANGE_JUMP_QIDENTIFIER,
    CHANGE_PASS_VALIDATE,
    CHANGE_QUESTIONNAIRE_CODE,
    CHANGE_CURRENT_PAGE_FILL_ANSWER,
    CHANGE_PAGE_ENV_INFO,
    CHANGE_HAS_SHOW_COVER_PAGE,
    CHANGE_JUMP_TO_END_FLAG,
    CHANGE_APP_SHARE_FLAG,
    CHANGE_REWARD_CONFIG,
    CHANGE_SECACCOUNT
} from '@/libs/constant';
import { getQuestionConfig, postQuestionAnswer, getExistImages } from '@/apis/index';
import { initShare } from '@/libs/share';
import router from '@/router';
import { QuestionRequire, CoverFlag, ShareFlag } from '@/libs/enum';
import md5 from 'md5';
import { imageUrl } from '@/libs/tool';
// import Cookies from 'js-cookie';
// import { result } from '@/mock/result';

Vue.use(Vuex);
/**
 * 从URL中提取hash路由里的查询参数
 * @param {string} paramName 要提取的参数名
 * @returns {string|null} 参数值，参数不存在则返回null
 */
function getHashRouteParam(paramName) {
    const url = window.location.href;
    // 拆分获取hash片段中的查询字符串
    const hashPart = url.split('#')[1] || '';
    const searchString = hashPart.split('?')[1] || '';
    // 解析并返回目标参数
    const searchParams = new URLSearchParams(searchString);
    return searchParams.get(paramName);
}

export default new Vuex.Store({
    state: {
        page: {},
        displayQuestions: [],
        isSinglePage: false,
        currentPage: 1,
        currentPageFillAnswer: false, // 表明当前页是否已经填了所有答案，用户控制页面底部按钮的可点击状态
        currentAnswerQuestionIndex: 0, // 当前答题第几题
        jumpQidentifierCollect: {}, // 保存每一页的跳转目标逻辑，当前页没有跳转到其他页的逻辑，则跳转状态未null
        jumpHistoryStack: [],
        passValidate: null,
        questionnaireCode: '',
        needLogin: true,
        questionnaireTitle: '',
        desc: '',
        submitText: '',
        submitUrl: '',
        answerConstraint: {},
        deviceInfo: {
            terminalType: 'wechat',
            deviceId: ''
        },
        shareInfo: {},
        shareFlag: ShareFlag.yes,
        configFailHint: '',
        questionFail: false,
        coverConfig: {},
        hasShowCoverPage: false,
        jumpToEndFlag: false,
        rewardConfig: {},
        isRequestLoading: false,
        loginFlag: '0', // 登录标志
        // 图片配置
        pictureConfig: {
            h5Bg: '',
            webBg: '',
            btnBg: ''
        },
        skin: 'light', // light, dark
        // 客户号+资金账号
        tradeAccount: '',
        // 加密的客户号+资金账号
        encryptTradeAccount: '',
        // 为了客服提出的，支持在链接后面添加一个加密串，这样问卷可以免登录
        secaccount: getHashRouteParam('secaccount') || undefined
    },
    publicKey: '', // begin接口返回的公钥
    getters: {
        hasGetQuestionnaire(state) {
            return !!state.questionnaireTitle;
        },
        // 只有登录的用户才能上传图片
        isCanUploadImage(state) {
            return state.loginFlag === '1';
        },
        isFinishPage(state) {
            // 最后一页
            return state.currentPage === Object.keys(state.page).length;
        },
        allPageLength(state) {
            return Object.keys(state.page).length;
        },
        questionNumber(state) {
            // 问卷所有可答题总数
            let number = 0;
            const keys = Object.keys(state.page);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                if (Array.isArray(state.page[key])) {
                    // number += state.page[key].length;
                    for (let j = 0; j < state.page[key].length; j++) {
                        const question = state.page[key][j];
                        if (question.show) {
                            number += 1;
                        }
                    }
                }
            }
            return number;
        },
        firstToCurrentPageQuestionNumber(state) {
            // 当前页面之前所有页数的所有可答题的题目数量总和
            let number = 0;
            for (let i = 0; i < Number(state.currentPage); i++) {
                if (Array.isArray(state.page[i])) {
                    // number += state.page[i].length;
                    for (let j = 0; j < state.page[i].length; j++) {
                        const ques = state.page[i][j];
                        if (ques.show) {
                            number += 1;
                        }
                    }
                }
            }
            return number;
        },
        currentPageFillAnswer(state) {
            const group = state.page[state.currentPage];
            const isHave = judgeGroupHaveAnswer(group);
            return isHave;
        },
        firstToCurrentPageAllAnswerNumber(state) {
            if (Number(state.currentPage) === 1) {
                const group = state.page[state.currentPage];
                const isHave = judgeGroupExistAnswer(group);
                if (!isHave) {
                    return 0;
                }
            }
            let number = 0;
            for (let i = 0; i <= Number(state.currentPage); i++) {
                if (Array.isArray(state.page[i])) {
                    if (i < Number(state.currentPage)) {
                        /**
                         * 存在这跳题逻辑和非必填的题目，没有答案不计入
                         */
                        for (let j = 0; j < state.page[i].length; j++) {
                            const ques = state.page[i][j];
                            if (ques.show && ques.anwser && ques.anwser.length) {
                                number += 1;
                            }
                        }
                    } else {
                        for (let j = 0; j < state.page[i].length; j++) {
                            const ques = state.page[i][j];
                            // ques.requireFlag === QuestionRequire.no;
                            if (ques.show && ques.anwser && ques.anwser.length) {
                                number += 1;
                            }
                        }
                    }
                }
            }
            return number;
        }
    },
    mutations: {
        [CHANGE_PAGE](state, payload) {
            state.page = payload;
        },
        [CHANGE_DISPLAY_QUESTION](state, payload) {
            state.displayQuestions = payload;
        },
        [CHANGE_IS_SINGLE_PAGE](state, payload) {
            state.isSinglePage = payload;
        },
        [CHANGE_CURRENT_PAGE](state, payload) {
            state.currentPage = payload;
        },
        [CHANGE_JUMP_HISTORY_STACK](state, payload) {
            state.jumpHistoryStack = payload;
        },
        [CHANGE_JUMP_QIDENTIFIER](state, payload = {}) {
            state.jumpQidentifierCollect = payload;
        },
        [CHANGE_PASS_VALIDATE](state, payload) {
            state.passValidate = payload;
        },
        [CHANGE_QUESTIONNAIRE_CODE](state, payload) {
            state.questionnaireCode = payload;
        },
        [CHANGE_CURRENT_PAGE_FILL_ANSWER](state, payload) {
            state.currentPageFillAnswer = payload;
        },
        [CHANGE_PAGE_ENV_INFO](state, payload) {
            state.deviceInfo = payload;
        },
        [CHANGE_HAS_SHOW_COVER_PAGE](state, payload) {
            state.hasShowCoverPage = !!payload;
        },
        setNeedLogin(state, payload) {
            state.needLogin = payload;
        },
        setQuestionnaireTitle(state, payload) {
            state.questionnaireTitle = payload;
        },
        setDesc(state, payload) {
            state.desc = payload;
        },
        setSubmitInfo(state, payload) {
            state.submitText = payload.submitText;
            state.submitUrl = payload.submitUrl;
        },
        setAnswerConstraint(state, payload = {}) {
            state.answerConstraint = payload;
        },
        setConfigFailHint(state, payload) {
            state.configFailHint = payload;
        },
        setQuestionFail(state, payload = false) {
            state.questionFail = payload;
        },
        setShareInfo(state, payload) {
            state.shareInfo = payload;
        },
        setCoverConfig(state, payload = {}) {
            state.coverConfig = payload;
        },
        setIsRequestLoading(state, payload) {
            state.isRequestLoading = !!payload;
        },
        [CHANGE_JUMP_TO_END_FLAG](state, payload = false) {
            state.jumpToEndFlag = payload;
        },
        [CHANGE_APP_SHARE_FLAG](state, payload = '1') {
            state.shareFlag = payload;
        },
        [CHANGE_REWARD_CONFIG](state, payload = {}) {
            state.rewardConfig = payload;
        },
        setLoginFlag(state, payload) {
            state.loginFlag = payload;
        },
        setPictureConfig(state, payload = {}) {
            state.pictureConfig = payload;
        },
        setSkin(state, payload) {
            state.skin = payload;
        },
        setTradeAccount(state, payload = {}) {
            // 设置不加密
            state.tradeAccount = `${payload.decryptCustomerId}|${payload.decryptUserId}`;
        },
        setEncryptTradeAccount(state, payload = {}) {
            // 设置加密的
            state.encryptTradeAccount = `${payload.customerId}|${payload.userId}`;
        },
        setPublicKey(state, publicKey) {
            state.publicKey = publicKey;
        },
        [CHANGE_SECACCOUNT](state, payload = undefined) {
            state.secaccount = payload;
        }
    },
    actions: {
        async getQuestionConfig({ commit, dispatch }, code) {
            commit(CHANGE_QUESTIONNAIRE_CODE, code);
            commit('setIsRequestLoading', true);
            try {
                const questionResult = await getQuestionConfig(code);
                // const questionResult = result;
                console.log(questionResult.data.data);
                // 取出publicKey并存入state
                if (
                    questionResult.data &&
                    questionResult.data.data &&
                    questionResult.data.data.publicKey
                ) {
                    commit('setPublicKey', questionResult.data.data.publicKey);
                }
                commit('setIsRequestLoading', false);
                const { needLogin, questionnaireConfig, fail, failHint } = questionResult.data.data;
                commit('setNeedLogin', needLogin);
                const { shareFlag } = questionnaireConfig || {};
                commit(CHANGE_APP_SHARE_FLAG, !!shareFlag);
                const defaultShareInfo = {
                    title: (questionnaireConfig && questionnaireConfig.shareTitle) || '问卷',
                    img: 'https://emfed.eastmoney.com/public/resource/img/wechatlogo.png',
                    url: `${window.location.origin}${window.location.pathname}#/cover?code=${code}`,
                    desc:
                        (questionnaireConfig && questionnaireConfig.shareText) || '欢迎参与问卷调研'
                };
                commit('setQuestionFail', fail);
                if (fail) {
                    // Toast(failHint);
                    commit('setShareInfo', defaultShareInfo);
                    commit('setConfigFailHint', failHint);
                    dispatch('setupFail');
                    return;
                }
                if (questionnaireConfig) {
                    const {
                        coverConfig,
                        questionnaireTitle,
                        desc,
                        shareTitle,
                        shareText,
                        submitText,
                        submitUrl,
                        answerConstraint,
                        rewardConfig,
                        loginFlag,
                        questions,
                        pictureConfig
                    } = questionnaireConfig;
                    // 获取图片数据
                    const res = await getExistImages(code);
                    const { data } = res;
                    if (data?.success) {
                        const imageConfigs = data.data || [];
                        const imageConfigMap = new Map(
                            imageConfigs.map(item => [item.qidentifier, item])
                        );
                        questions.forEach(q => {
                            const config = imageConfigMap.get(q.qidentifier);
                            if (config?.picCodes?.length) {
                                q.fileUrls = config.picCodes.map(code => imageUrl(code));
                            }
                        });
                    }
                    commit('setQuestionnaireTitle', questionnaireTitle);
                    commit('setDesc', desc);
                    commit('setSubmitInfo', { submitText, submitUrl });
                    commit('setAnswerConstraint', answerConstraint);
                    commit(CHANGE_REWARD_CONFIG, rewardConfig);
                    commit('setLoginFlag', loginFlag);
                    dispatch('setupTitle');
                    const shareInfo = {
                        ...defaultShareInfo,
                        title: shareTitle || '问卷',
                        img: 'https://emfed.eastmoney.com/public/resource/img/wechatlogo.png',
                        url: `${window.location.origin}${window.location.pathname}#/cover?code=${code}`,
                        desc: shareText
                    };
                    commit('setShareInfo', shareInfo);
                    dispatch('setupShare');
                    commit('setCoverConfig', coverConfig || {});
                    commit('setPictureConfig', pictureConfig || { h5Bg: '' });
                    const page = pageByGroup(questionnaireConfig.questions);
                    const isSinglePage = checkIsSinglePage(page);
                    commit(CHANGE_PAGE, page);
                    // 默认 第一页
                    commit(CHANGE_IS_SINGLE_PAGE, isSinglePage);
                    commit(CHANGE_DISPLAY_QUESTION, page[1]);
                    dispatch('setupToCoverPage');
                } else {
                    commit('setShareInfo', {
                        title: '东方财富问卷',
                        img: 'https://emfed.eastmoney.com/public/resource/img/wechatlogo.png',
                        url: window.location.href,
                        desc: ''
                    });
                    dispatch('setupShare');
                }
            } catch (error) {
                commit('setIsRequestLoading', false);
                console.log(error);
            }
        },
        setPublicKey(state, publicKey) {
            state.publicKey = publicKey;
        },
        setupFail({ state, dispatch }) {
            dispatch('setupShare');
            const { questionnaireCode, secaccount } = state;
            const { name: routeName } = router.currentRoute;
            if (routeName !== 'fail') {
                router.replace({ name: 'fail', query: { code: questionnaireCode, secaccount } });
            }
        },
        setupShare({ state }) {
            const { shareInfo, shareFlag } = state;
            const shareEl = initShare(shareInfo, shareFlag);
            Vue.prototype.$wxShare = shareEl;
        },
        setupTitle({ state }) {
            const { questionnaireTitle } = state;
            document.title = questionnaireTitle || '东方财富问卷';
            const isApp = browser.isApp();
            if (isApp) {
                setTimeout(() => {
                    setTitle(questionnaireTitle || '东方财富问卷');
                }, 200);
            }
        },
        setupToCoverPage({ state }) {
            const { questionnaireCode, coverConfig, hasShowCoverPage, secaccount } = state;
            const { name: routeName } = router.currentRoute;
            // 不需要封皮
            if (
                (!coverConfig.coverFlag || coverConfig.coverFlag === CoverFlag.no) &&
                routeName !== 'home'
            ) {
                router.replace({
                    name: 'home',
                    params: { code: questionnaireCode },
                    query: { secaccount }
                });
                return;
            }
            // 当前
            if (
                coverConfig.coverFlag === CoverFlag.yes &&
                routeName !== 'cover' &&
                !hasShowCoverPage
            ) {
                router.replace({ name: 'cover', query: { code: questionnaireCode, secaccount } });
            }
        },
        jumpSingleQuestion({ commit, state }, payload = {}) {
            // 验证本页面的必填
            const currentGroup = state.page[state.currentPage];
            const validate = validatorQuestion(currentGroup);
            if (validate.qidentifier || validate.optionIdentifier) {
                commit(CHANGE_PASS_VALIDATE, validate);
                const elmnt = document.getElementById(validate.qidentifier);
                elmnt.scrollIntoView({ behavior: 'smooth' });
                return;
            }
            commit(CHANGE_PASS_VALIDATE, null);
            // 对当前页展示的入历史栈
            commit(CHANGE_JUMP_HISTORY_STACK, [
                ...state.jumpHistoryStack,
                {
                    page: state.currentPage,
                    group: state.displayQuestions
                }
            ]);
            const groupData = jumpSinglePage(
                state.page,
                state.currentPage,
                payload.jumpQidentifier,
                payload.toEnd
            );
            commit(CHANGE_DISPLAY_QUESTION, groupData.group);
            commit(CHANGE_CURRENT_PAGE, groupData.pageNum);
            commit(CHANGE_JUMP_TO_END_FLAG, !!payload.toEnd);
        },
        prejumpPage({ commit, state }) {
            if (!state.jumpHistoryStack || !state.jumpHistoryStack.length) {
                return;
            }
            const history = state.jumpHistoryStack[state.jumpHistoryStack.length - 1];
            commit(CHANGE_DISPLAY_QUESTION, history.group);
            commit(CHANGE_CURRENT_PAGE, history.page);
            commit(
                CHANGE_JUMP_HISTORY_STACK,
                state.jumpHistoryStack.slice(0, state.jumpHistoryStack.length - 1)
            );
        },
        jumpMultiNextPage({ commit, state }) {
            const allPage = Object.keys(state.page).length;
            // 验证本页面的必填
            const currentGroup = state.page[state.currentPage];
            // 问卷必填逻辑的校验
            const validate = validatorQuestion(currentGroup);
            if (validate.qidentifier || validate.optionIdentifier) {
                commit(CHANGE_PASS_VALIDATE, validate);
                const elmnt = document.getElementById(validate.qidentifier);
                elmnt.scrollIntoView({ behavior: 'smooth' });
                return;
            }
            commit(CHANGE_PASS_VALIDATE, null);
            // 对当前页展示的入历史栈
            commit(CHANGE_JUMP_HISTORY_STACK, [
                ...state.jumpHistoryStack,
                {
                    page: state.currentPage,
                    group: state.displayQuestions
                }
            ]);
            const jumpQid = state.jumpQidentifierCollect[state.currentPage];
            console.log('jumpQid -- ', jumpQid);
            if (!jumpQid) {
                let jumpPage = Number(state.currentPage) + 1;
                let group = state.page[`${jumpPage}`];
                console.log('orderNextPage --->> ', jumpPage, group);
                // 存在下一页的所有题目都是有关联逻辑，没有被显示的题目，所以直接跳过当前页
                while (!checkGroupExistShow(group) && jumpPage <= allPage) {
                    jumpPage += 1;
                    group = state.page[`${jumpPage}`];
                }
                commit(CHANGE_DISPLAY_QUESTION, group);
                commit(CHANGE_CURRENT_PAGE, jumpPage);
            } else {
                const jumpPage = findPageIdex(jumpQid, state.page);
                if (Number(jumpPage) > Number(state.currentPage) + 1) {
                    const page = hideBetweenPage(state.page, state.currentPage, jumpPage);
                    commit(CHANGE_PAGE, { ...page });
                }
                const group = state.page[`${jumpPage}`];
                console.log('jumpPage --->> ', jumpPage, group);
                commit(CHANGE_DISPLAY_QUESTION, getMultiNextGroup(group, jumpQid));
                commit(CHANGE_CURRENT_PAGE, jumpPage);
            }
        },
        async submit({ state, commit }, requestAnswer = {}) {
            const { data } = await postQuestionAnswer(state.questionnaireCode, requestAnswer);
            if (data.success) {
                // Toast('问卷提交成功');
                if (data.data.token) {
                    commit(CHANGE_REWARD_CONFIG, {
                        ...state.rewardConfig,
                        rewardToken: data.data.token
                    });
                }
                return true;
            }
            Toast(data.message);
            return false;
        },
        async submitQuestionnaire({ state, commit, dispatch }) {
            const currentGroup = state.page[state.currentPage];
            const validate = validatorQuestion(currentGroup);
            if (validate.qidentifier || validate.optionIdentifier) {
                commit(CHANGE_PASS_VALIDATE, validate);
                const elmnt = document.getElementById(validate.qidentifier);
                elmnt.scrollIntoView({ behavior: 'smooth' });
                return;
            }
            const answers = getAllAnswer(state.page);
            console.log(answers);
            const requestAnswer = {
                questionAnswers: answers,
                check: md5(Date.now().toString())
            };
            return dispatch('submit', requestAnswer);
        },
        async submitInvalidQuestionnaire({ state, dispatch }, payload) {
            const requestAnswer = {
                questionAnswers: [payload],
                check: md5(`${state.questionnaireCode}无效问卷`)
            };
            return dispatch('submit', requestAnswer);
        }
    },
    modules: {}
});
